import { LanguageBackendType } from "../shared/components/language/types";
import { DEFAULT_TELEPHONE_CODE } from "../shared/types";
import { BasicAccountBenefitsModel } from "./types";

// We create new object with function because Formik has some issues with "touched" with objects having nested objects.
const createDefaultContactData = () => ({
  gender: "",
  firstName: "",
  lastName: "",
  mobile: {
    code: DEFAULT_TELEPHONE_CODE,
    number: "",
  },
  emailBusiness: "",
  correspondenceLanguage: LanguageBackendType.GERMAN,
});

export const defaults: BasicAccountBenefitsModel = {
  hasCashOnCard: "yes",
  hasLoyalties: "no",
  customizedCard: "NONE",
  plusPartnerUsername: null,
  isContactPersonSame: "yes",
  contactPerson: createDefaultContactData(),
  adminContactPerson: createDefaultContactData(),
  partnerPlusBenefitGeneralDto: {
    receiveInfoMail: false,
    sendNewsletters: false,
    companyTravelersCount: null,
    expectedAnnualFlightSpending: null,
    companyPosition: "",
    companyDepartment: "",
  },
};
